import React, { FC, useMemo } from 'react';
import ColoredSelect from 'pages/Quotes/components/generics/Select/ColoredSelect';
import { DropdownCDsProps } from '../../interface';

export const DropdownCDs: FC<DropdownCDsProps> = (props) => {
  const {
    index,
    disabled,
    isEditing,
    cdsPitagoras,
    valueSelectDC,
    setSelectedDc,
    lengthQuoteItem,
    distributionCenter,
    stockAvailableList,
    setSelectedPitagoras,
    valueSelectDCPitagoras,
    distributionCenterPitagoras
  } = props;

  const enhancedStockAvailableList = stockAvailableList;
  const enhancedCdsPitagoras = cdsPitagoras;

  return (
    <div className="containerColorSelected">
      <div className="headerQuoteItem">
        <span className="subtitle">Orçamento</span>
        <div className="value" style={{ alignItems: "baseline" }}>
          {!isEditing ? (
            <div className="value" style={{ alignItems: "baseline" }}>
              {distributionCenter}
            </div>
          ) : (
            <ColoredSelect
              index={index!}
              disabled={disabled}
              value={valueSelectDC}
              setSelected={setSelectedDc}
              lengthQuoteItem={lengthQuoteItem}
              distributionCenterList={enhancedStockAvailableList}
            />
          )}
        </div>
      </div>

      <div className="headerQuoteItem">
        <span className="subtitle">Pitágoras</span>
        <div className="value" style={{ alignItems: "baseline" }}>
          {!isEditing ? (
            <div className="value" style={{ alignItems: "baseline" }}>
              {distributionCenterPitagoras}
            </div>
          ) : (
            <ColoredSelect
              index={index! + 1}
              disabled={disabled}
              value={valueSelectDCPitagoras}
              setSelected={setSelectedPitagoras}
              distributionCenterList={enhancedCdsPitagoras}
              lengthQuoteItem={lengthQuoteItem}
            />
          )}
        </div>
      </div>
    </div>
  );
};
